import React from "react";
import { Accounts } from "../../components/MerchantAccounts";
import { connect } from "react-redux";
import { DashboardHeader } from "../../components/Header";

class AccountScreen extends React.Component {
  render() {
    return (
      <div className="card">
        <div className="card-body">
          <DashboardHeader title={"Accounts"} titleClassName="text-primary" />
          <Accounts showAdd />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(AccountScreen);
